import React from 'react';
import {images} from '../lib/config';

class Footer extends React.Component {

  render(){
    return(
      <div className="footer">
        <h5 className="col-xs-3 col-sm-3 col-md-2"><b>Supported By</b></h5>
        <h5 className="col-xs-3 col-sm-4 col-md-7"><br/>
          <b>Langtang National Park and Buffer Zone Support Project </b><br/>
        </h5>
        <div className="col-xs-3 col-sm-3 col-md-3 footer">
          <div className=""><img className="img-responsive pull-right" style={{height:'110px'}} src={images.wwf} alt="" /></div>
          <div className=""><img className="img-responsive pull-right" style={{height:'100px'}} src={images.langtangNational} alt="" /></div>
          {/*<div className="col-xs-3 col-sm-4 col-md-5"><img className="img-responsive" style={{height:'100px'}} src={images.UNDP} alt="" /></div>*/}
        </div>
      </div>
    );
  }

}
export default Footer;



// WEBPACK FOOTER //
// ./src/component/common/Footer.js